import React, { useState } from "react";
import styled from "styled-components";
import { useDispatch, useSelector } from "react-redux";
import { setLoggedInGuest, setLoggedInUser } from "../../shared/slice/auth/AuthSlice";
import { AcceptTermsPopup } from "../../shared/slice/auth/AuthService";
import { useTranslation } from "react-i18next";

const PopupContainer = styled.div`
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  background: #fefefe;
  box-shadow: 0 -4px 20px rgba(0, 0, 0, 0.15);
  z-index: 1050;
  padding: 0.8rem 1rem;
  display: flex;
  justify-content: center;
  align-items: center;
  border-top: 3px solid #eb1700;
`;

const Content = styled.div`
  display: flex;
  flex-direction: row; 
  align-items: center;
  max-width: 700px;
  width: 100%;
  gap: 0.5rem;
  flex-wrap: wrap; 
  justify-content: center; 

  @media (max-width: 480px) {
    flex-wrap: nowrap; 
    justify-content: flex-start;
    padding: 0 0.5rem;
  }

  p {
    font-size: 0.9rem;
    margin: 0;
    color: #333;
    white-space: nowrap; 

    @media (max-width: 480px) {
      font-size: 0.5rem; 
    }

    a {
      color: #eb1700;
      font-weight: 600;
      text-decoration: underline;

      &:hover {
        opacity: 0.8;
      }
    }
  }
`;

const CheckboxContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  white-space: nowrap; 

  @media (max-width: 480px) {
    gap: 0.3rem;
  }

  label {
    font-size: 0.5rem;
    display: flex;
    align-items: center;
    gap: 0.5rem;
    cursor: pointer;
    color: #333;

    @media (max-width: 480px) {
      font-size: 0.5rem;
      gap: 0.3rem;
    }
  }

  input[type="checkbox"] {
    width: 16px;
    height: 16px;
    cursor: pointer;
    appearance: none;
    border: 2px solid #eb1700;
    border-radius: 4px;
    background-color: white;
    position: relative;
    transition: all 0.2s;

    @media (max-width: 480px) {
      width: 14px;
      height: 14px;
    }

    &:checked {
      background-color: #eb1700;
      border-color: #eb1700;
    }

    &:checked::after {
      content: "";
      position: absolute;
      top: 1px;
      left: 5px;
      width: 3px;
      height: 7px;
      border: solid white;
      border-width: 0 2px 2px 0;
      transform: rotate(45deg);

      @media (max-width: 480px) {
        top: 0;
        left: 4px;
        width: 3px;
        height: 6px;
      }
    }
  }
`;

const TermsPopup = () => {
  const dispatch = useDispatch();
  const user = useSelector((state) => state.authentification.loggedInUser);
  const guest = useSelector((state) => state.authentification.loggedInGuest);
  const [checked, setChecked] = useState(false);
  const { t } = useTranslation();

  const currentUser = user || guest;
  const userType = user ? 'user' : 'guest';

  const handleCheckboxChange = async () => {
    const newChecked = !checked;
    setChecked(newChecked);

    if (newChecked && currentUser) {
      try {
        await AcceptTermsPopup(currentUser._id, userType); 

        // Met à jour le store Redux
        if (user) {
          dispatch(setLoggedInUser({ user: { ...user, termsAccepted: true } }));
        } else if (guest) {
          dispatch(setLoggedInGuest({ guest: { ...guest, termsAccepted: true } }));
        }

        localStorage.setItem("termsAccepted", "true");
      } catch (error) {
        console.error("Erreur lors de l'acceptation des termes :", error);
        setChecked(false);
      }
    }
  };

  return (
    <PopupContainer>
      <Content>
        <CheckboxContainer>
          <input
            type="checkbox"
            checked={checked}
            onChange={handleCheckboxChange}
          />
          <p>
            {t('By continuing, you accept our')}{" "}
            <a
              href="/terms-of-service"
              target="_blank"
              rel="noopener noreferrer"
            >
              {t('General Conditions')}
            </a>
            {" "}
            &
            {" "}
            <a
              href="/privacy-policy"
              target="_blank"
              rel="noopener noreferrer"
            >
             {t('Privacy Policy')}
            </a>
          </p>


        </CheckboxContainer>
      </Content>
    </PopupContainer>
  );
};

export default TermsPopup;
